import actionTypes from './formTemplates.actionTypes';
import firstBy from 'thenby';


const initialState = {
  companyId: '',
  employeeId: '',
  isLoading: false,
  templates: [],
  defaultTemplates: [],
};


export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_FORM_TEMPLATES_BEGIN: return fetchFormTemplatesBegin(state, action);
    case actionTypes.FETCH_FORM_TEMPLATES_SUCCESS: return fetchFormTemplatesSuccess(state, action);
    case actionTypes.FETCH_FORM_TEMPLATES_FAILURE: return fetchFormTemplatesFailure(state);

    case actionTypes.FETCH_DEFAULT_FORM_TEMPLATES_BEGIN: return fetchDefaultFormTemplatesBegin(state, action);
    case actionTypes.FETCH_DEFAULT_FORM_TEMPLATES_SUCCESS: return fetchDefaultFormTemplatesSuccess(state, action);
    case actionTypes.FETCH_DEFAULT_FORM_TEMPLATES_FAILURE: return fetchDefaultFormTemplatesFailure(state);

    default:
      return state;
  }
}

const fetchFormTemplatesBegin = (state, { payload }) => {
  return {
    ...state,
    isLoading: true,
    companyId: payload.companyId,
    employeeId: payload.employeeId,
  };
};

const fetchFormTemplatesSuccess = (state, action) => {
  let templates = action.data;

  let sorting = { field: "name", direction: "asc" };
  let sortedTemplates = sortTemplates(sorting, templates);

  let defaultTemplates = sortedTemplates.filter(x => {
    return x.isDefaultTemplate === true;
  });

  return {
    ...state,
    isLoading: false,
    templates: [...templates],
    defaultTemplates: [...defaultTemplates]
  };
};

const fetchFormTemplatesFailure = state => {
  return {
    ...state,
    isLoading: false
  };
};


const fetchDefaultFormTemplatesBegin = (state, { payload }) => {
  return {
    ...state,
    isLoading: true,
    companyId: payload.companyId,
    employeeId: payload.employeeId,
  };
};

const fetchDefaultFormTemplatesSuccess = (state, action) => {
  let templates = action.data;

  let sorting = { field: "name", direction: "asc" };
  let sortedTemplates = sortTemplates(sorting, templates);

  let defaultTemplates = sortedTemplates.filter(x => {
    return x.isDefaultTemplate === true;
  });

  return {
    ...state,
    isLoading: false,
    defaultTemplates: [...defaultTemplates]
  };
};

const fetchDefaultFormTemplatesFailure = state => {
  return {
    ...state,
    isLoading: false
  };
};

const sortTemplates = (sorting, templates) => {
  let field = "name";
  let direction = "desc";

  let workingArray = [...templates];
  if (field && direction) {
    workingArray.sort(firstBy(sorting.field, sorting.direction === 'desc' ? -1 : undefined));
  }

  return workingArray;
};
